export default __webpack_public_path__ + "30b17457462ca9a40678cae752a940a0.png";